









































































// @ts-nocheck
import { dictServe, regionServe } from '@/api/installServer';

let map: any;
const zoom = 14;
const handler: any = [];
let img: any;

import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ProfessionEdit extends Vue {
  @PropSync('showFlag', Number) pageFlag!: number; // 显示哪个页面flag
  @Prop(Object) row!: Record<string, any>; // 传递给编辑页面的表单数据对象
  antiShake = true; // 防抖判断
  showWhatFlag = true; // 展示哪个页面：编辑或新增
  // 表单数据对象
  formData: any = {
    id: '',
    buildingHeight: '',
    areaType: '',
    baseRiskLevel: '',
  };

  index = 0;

  img_nj: any;
  img_jzs: any;

  option: any = [];

  areaTypeOptions: any = [];
  areaBaseRiskLevelOptions: any = [];

  /**
   * @todo 后期需要优化的部分
   * @desc Vue数据加载生命周期函数
   * @param1 无
   * @returns 无
   */
  async created() {
    this.getDistOptions();
  }

  mounted() {
    this.formData = this.row;
    this.getDataById();
  }

  getDistOptions() {
    // 获取单个数据
    dictServe
      .getDetailsMapByName('areaBaseRiskLevel')
      .then((res: any) => {
        if (res.code === '200') {
          for (const i in res.data) {
            this.areaBaseRiskLevelOptions.push({
              value: [i].toString(),
              name: res.data[i],
            }); //属性
          }
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });

    dictServe
      .getDetailsMapByName('areaType')
      .then((res: any) => {
        if (res.code === '200') {
          for (const i in res.data) {
            this.areaTypeOptions.push({
              value: [i].toString(),
              name: res.data[i],
            }); //属性
          }
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
  }

  showMap() {
    // [104.55, 22.9]

    // console.log('showMap');
    // map = new T.Map('mapDiv', {
    //   projection: 'EPSG:4326'
    // });
    // map.centerAndZoom(new T.LngLat(104.55, 22.9), zoom);

    const imageURL = 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=4c3a4b8cec3d4af47a12cdd192ce35cb';
    //创建自定义图层对象
    const lay = new T.TileLayer(imageURL, { minZoom: 13, maxZoom: 18 });
    map = new T.Map('mapDiv', { layers: [lay] });
    map.centerAndZoom(new T.LngLat(104.101452, 30.659966), zoom);

    const typeArr: any = [
      {
        // title: '卫星',
        title: '',
        icon: ' http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellite.png',
        layer: TMAP_SATELLITE_MAP,
      },
      {
        // title: '地图', //地图控件上所要显示的图层名称
        title: '', //地图控件上所要显示的图层名称
        icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png', //地图控件上所要显示的图层图标（默认图标大小80x80）
        layer: TMAP_NORMAL_MAP, //地图类型对象，即MapType。
      },
      // {
      //   title: '卫星混合',
      //   icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellitepoi.png',
      //   layer: TMAP_HYBRID_MAP,
      // },
      // {
      //   title: "地形",
      //   icon: " http://api.tianditu.gov.cn/v4.0/image/map/maptype/terrain.png",
      //   layer: "TMAP_TERRAIN_MAP"
      // },
      // {
      //   title: "地形混合",
      //   icon: " http://api.tianditu.gov.cn/v4.0/image/map/maptype/terrainpoi.png",
      //   layer: "TMAP_TERRAIN_HYBRID_MAP"
      // }
    ];
    const ctrl = new T.Control.MapType(typeArr);
    //添加控件
    map.addControl(ctrl);

    map.addEventListener('maptypechange', (e: any) => {
      console.log(e);
      //e.mapType 就是 当前切换的MapType 配置的地图
      if (e.mapType.name == 'TMAP_NORMAL_MAP') {
        // 普通地图 覆盖图隐藏
        this.img_nj.hide();
        this.img_jzs.hide();
      } else {
        this.img_nj.show();
        this.img_jzs.show();
      }
    });

    map.setMinZoom(13);
    map.setMaxZoom(18);

    // map.setMaxBounds(new T.LngLatBounds(new T.LngLat(104.45, 22.84), new T.LngLat(104.65, 22.96)));

    // this.setMapImg();

    // 绘制区域
    // let points = [];
    // points.push(new T.LngLat(104.54727, 22.91413));
    // points.push(new T.LngLat(104.54092, 22.89958));
    // points.push(new T.LngLat(104.56289, 22.89278));
    // points.push(new T.LngLat(104.55877, 22.91002));
    // //创建面对象
    // let polygon = new T.Polygon(points,{
    //   color: "blue", weight: 3, opacity: 0.5, fillColor: "#FFFFFF", fillOpacity: 0.5
    // });
    // //向地图上添加面
    // map.addOverLay(polygon);
    this.formData.mapPoint &&
      this.formData.mapPoint.pointArr.forEach((item: any) => {
        const points: any = [];
        item.forEach((itemC: any) => {
          points.push(new T.LngLat(itemC.lng, itemC.lat));
        });
        //创建面对象
        const polygon = new T.Polygon(points, {
          color: '#f14343',
          weight: 2,
          opacity: 1,
          fillColor: '#f14343',
          fillOpacity: 0.2,
        });
        //向地图上添加面
        map.addOverLay(polygon);
      });

    const config = {
      showLabel: true,
      color: '#f14343',
      weight: 2,
      opacity: 1,
      fillColor: '#f14343',
      fillOpacity: 0.2,
    };
    //创建标注工具对象
    const polygonTool = new T.PolygonTool(map, config);
  }

  setMapImg() {
    const bd = new T.LngLatBounds(new T.LngLat(104.5238, 22.85528), new T.LngLat(104.601, 22.932));
    this.img_jzs = new T.ImageOverlay('map/img/map-all.png', bd, {
      opacity: 1,
      alt: '', // 名称
    });
    map.addOverLay(this.img_jzs);

    // const bd = new T.LngLatBounds(new T.LngLat(104.5548, 22.8871), new T.LngLat(104.5648, 22.8924));
    // this.img_jzs = new T.ImageOverlay('map/img/map-s-jzs.png', bd, {
    //   opacity: 1,
    //   alt: '', // 名称
    // });
    // map.addOverLay(this.img_jzs);
    //
    // const bd_nj = new T.LngLatBounds(new T.LngLat(104.5573, 22.8752), new T.LngLat(104.5773, 22.8856));
    // this.img_nj = new T.ImageOverlay('map/img/map-s-nj.png', bd_nj, {
    //   opacity: 1,
    //   alt: '', // 名称
    // });
    // map.addOverLay(this.img_nj);
  }

  getDataById() {
    regionServe
      .getRegionDataById(this.formData.id)
      .then((res: any) => {
        if (res.code === '200') {
          // this.formData = res.data;
          Vue.set(this, 'formData', res.data);
          this.showMap();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }

  /**
   * @desc 点击保存按钮触发，保存内容
   * @param1 暂无
   * @returns 暂无
   */
  save() {
    console.log(this.option);
    if (this.option.length > 0 || (this.formData.mapPoint && this.formData.mapPoint.pointArr && this.formData.mapPoint.pointArr.length > 0)) {
      const arr = this.formData.mapPoint ? this.formData.mapPoint.pointArr : [];
      (this.formData as any).mapPoint = {
        pointArr: [...this.option, ...arr],
      };
    } else {
      this.formData.mapPoint = null;
    }

    this.formData.areaId = this.formData.id;

    console.log(this.formData);

    regionServe
      .editRegionDrawData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('修改成功!');
          this.pageFlag = 1;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请重试!');
      });
  }

  openPolygonTool() {
    if (handler[this.index]) handler[this.index].close();
    handler[this.index] = new T.PolygonTool(map);
    handler[this.index].open();
    handler[this.index].addEventListener('draw', (e: any) => {
      console.log(e);
      this.option.push(e.currentLnglats);
      this.index += 1;
    });
  }

  clearAll() {
    console.log(map);
    this.$confirm('确认要清空数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        this.formData.mapPoint.pointArr = [];
        this.option = [];
        map.clearOverLays();
        this.setMapImg();
        // this.showMap();
      })
      .catch(() => {});
  }

  clearPolygonTool() {
    this.$confirm('确认要回退数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        // 点击确定
        handler[this.index - 1].clear();
        this.option.splice(this.index - 1, 1);
        this.index -= 1;
      })
      .catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除',
        // });
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  close() {
    this.pageFlag = 1; // 跳转到index页面
  }
}
